import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import { take, put, select, call, all } from 'redux-saga/effects';
import logger from '../../../logger/logger';
import { extractJson } from 'wfui-digital-core/es/lib';
import globals from '../../../globals/globals';
import getJson from '../../../network/get-json';
import { getDevice } from 'wfui-digital-core/es/selectors';
import { getLanguage } from '../../selectors';
import fetchMenuConfig from '../../../../components/menu-provider/support/fetch-menu-config';
import parseNavigationConfig from '../../../navigation/support/parse-navigation-config';
import parseCombinedConfig from '../../../navigation/support/parse-combined-config';
import extractNavigationItems from '../../../navigation/support/extract-navigation-items';
import isConfigValid from './support/is-config-valid';
import * as actions from '../actions';

var getMastheadNavigationConfig = function getMastheadNavigationConfig(_ref) {
  var language = _ref.language,
      device = _ref.device;

  if (globals().navMenuConfig) {
    var navigationConfig = globals().navMenuConfig;
    delete window.mwfGlobals.navMenuConfig;
    return extractJson(navigationConfig);
  } else {
    return getJson({
      url: "/navigationConfig/".concat(language, "/masthead/").concat(device.platform)
    });
  }
};

var getProfileMenuConfig = function getProfileMenuConfig() {
  if (globals().navProfileMenuConfig) {
    var navigationConfig = globals().navProfileMenuConfig;
    delete window.mwfGlobals.navProfileMenuConfig;
    return extractJson(navigationConfig);
  } else {
    return Promise.resolve(null);
  }
};

var getFooterNavigationConfig = function getFooterNavigationConfig(_ref2) {
  var language = _ref2.language,
      device = _ref2.device;

  if (globals().footerConfig) {
    var navigationConfig = globals().footerConfig;
    delete window.mwfGlobals.footerConfig;
    return extractJson(navigationConfig);
  } else {
    return getJson({
      url: "/navigationConfig/".concat(language, "/footer/").concat(device.platform)
    });
  }
};

export var watchFetchNavigationConfig = /*#__PURE__*/regeneratorRuntime.mark(function watchFetchNavigationConfig() {
  var language, device, mastheadNavigationConfig, footerNavigationConfig, menuConfig, allConfig, _yield$all, _yield$all2, mastheadConfig, footerConfig, profileConfig, navigationItems;

  return regeneratorRuntime.wrap(function watchFetchNavigationConfig$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 40;
            break;
          }

          _context.prev = 1;
          _context.next = 4;
          return take(actions.NAVIGATION_MENU_CONFIG_FETCH);

        case 4:
          _context.next = 6;
          return select(getLanguage);

        case 6:
          language = _context.sent;
          _context.next = 9;
          return select(getDevice);

        case 9:
          device = _context.sent;
          mastheadNavigationConfig = void 0, footerNavigationConfig = void 0;
          _context.next = 13;
          return call(fetchMenuConfig, {
            language: language,
            platform: device.platform
          });

        case 13:
          menuConfig = _context.sent;
          allConfig = parseCombinedConfig({
            device: device,
            containers: menuConfig.containers
          });
          mastheadNavigationConfig = allConfig.mastheadNavigationConfig;
          footerNavigationConfig = allConfig.footerNavigationConfig;

          if (!(!isConfigValid(mastheadNavigationConfig, device) && !isConfigValid(footerNavigationConfig, device) && !globals().hideMobileMastheadMenus)) {
            _context.next = 28;
            break;
          }

          _context.next = 20;
          return all([call(getMastheadNavigationConfig, {
            language: language,
            device: device
          }), call(getFooterNavigationConfig, {
            language: language,
            device: device
          }), call(getProfileMenuConfig)]);

        case 20:
          _yield$all = _context.sent;
          _yield$all2 = _slicedToArray(_yield$all, 3);
          mastheadConfig = _yield$all2[0];
          footerConfig = _yield$all2[1];
          profileConfig = _yield$all2[2];

          if (profileConfig) {
            mastheadConfig.profileMenu = profileConfig;
          }

          mastheadNavigationConfig = parseNavigationConfig({
            section: 'masthead',
            device: device,
            navigationConfig: mastheadConfig
          });
          footerNavigationConfig = parseNavigationConfig({
            section: 'footer',
            device: device,
            navigationConfig: footerConfig
          });

        case 28:
          navigationItems = extractNavigationItems({
            device: device,
            mastheadNavigationConfig: mastheadNavigationConfig,
            footerNavigationConfig: footerNavigationConfig
          });
          _context.next = 31;
          return put(actions.setPlatformName(footerNavigationConfig.platformName));

        case 31:
          _context.next = 33;
          return put(actions.setNavigationMenuItems({
            mastheadNavigationConfig: mastheadNavigationConfig,
            footerNavigationConfig: footerNavigationConfig,
            navigationItems: navigationItems
          }));

        case 33:
          _context.next = 38;
          break;

        case 35:
          _context.prev = 35;
          _context.t0 = _context["catch"](1);
          logger.error('Failed to load navigation configuration', _context.t0);

        case 38:
          _context.next = 0;
          break;

        case 40:
        case "end":
          return _context.stop();
      }
    }
  }, watchFetchNavigationConfig, null, [[1, 35]]);
});